// extracted by mini-css-extract-plugin
export default {"rec":"Recomendation_rec__fqzo0","songs":"Recomendation_songs__EZAi-","header":"Recomendation_header__9qZ-k"};